import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-import-file-modal',
  templateUrl: './import-file-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class ImportFileModalComponent {
  @Input() title: string = 'Uvezi fajl';
  @Input() description: string = 'Otpremite .xlsx fajl. Proverite da li su podaci u fajlu ispravno popunjeni pre potvrde.';

  selectedFile: File | null = null;
  fileName: string = '';

  @Output() readonly responseChanged = new EventEmitter();

  onFileChange(event: any): void {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
        this.selectedFile = file;
        this.fileName = file.name;
      }
    }
  }

  onRemoveFile(): void {
    this.selectedFile = null;
    this.fileName = '';
  }

  onImport(): void {
    this.responseChanged.emit(this.selectedFile);
  }

  onCancel(): void {
    this.responseChanged.emit(null);
  }
}
